import { ReactElement, ReactNode } from 'react'
import { ISelectOption } from '../fields/SelectField'

export enum Order {
  Asc = 'ascending',
  Desc = 'descending',
}
export interface ITableRequest<T> {
  limit: number
  skip: number
  orderDirection?: Order
  orderBy?: keyof T
  fromDate?: number
  toDate?: number
  search?: string
  slug?: string
}

export interface ITableData<T> {
  recordsTotal: number
  limit: number
  skip: number
  data: T[]
  recordsFiltered?: number
  startDate?: number
  endDate?: number
}

export type Update<T> = (key: keyof ITableRequest<T>, value: unknown) => void

export interface IColumn<T> {
  accessor?: keyof T
  header?: ReactNode
  parent?: string
  sorting?: false
  clickable?: false
  display?: (row: T) => ReactNode
}

export interface IFilterValue<T> {
  accessor: keyof T
  value?: T[keyof T]
  customLabel?: string
}

export interface IFilters<T> {
  accessor: keyof T
  options: ISelectOption<T[keyof T]>[]
  value?: T[keyof T]
  display?: (option: ISelectOption<unknown>) => ReactElement
  placeholder?: string
  slug?: true
  customLabel?: string
}

export interface IDates {
  startDate?: number
  endDate?: number
}

export interface IFiltered {
  recordsFiltered?: number
  recordsTotal?: number
}

export type RequestWithFilters<T, U extends IFilters<T>[]> = ITableRequest<T> &
{ [K in U[number]['accessor']]: T[K] }

export interface ITableProps<T> {
  fetch: (
    request: RequestWithFilters<T, IFilters<T>[]>,
  ) => Promise<ITableData<T>>
  columns: IColumn<T>[]
  rowLink?: {
    route?: string
    slug?: keyof T
    onClick?: (row: T) => void
    state?: { [key: string]: string }
  }
  options?: Partial<ITableRequest<T>>
  filters?: IFilters<T>[]
  search?: true | string
  restrictions?: RegExp
  dates?: true | IDates
  getState?: (params: RequestWithFilters<T, IFilters<T>[]>) => void
  getData?: (data: T[]) => void
  getFiltered?: (filtered: IFiltered) => void
  defaults?: object
  forgetful?: boolean
  reset?: boolean
  pagination?: false
  controls?: ReactNode
  customFilter?: {
    accessor: string
    options: ISelectOption<unknown>[]
    placeholder?: string
  }
}
